import React, { useState, useEffect, Suspense } from "react";
import {
  Container,
  createStyles,
  Grid,
  makeStyles,
  Theme,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { useImage } from "react-image";
import { useQuery } from "@apollo/client";
import { GET_MATERIAL_IMAGES_BY_SUB_CATEGORY_ID } from "../../../../../quries/material";
import Masonry from "react-masonry-css";
import styled from "styled-components";
import "./masonry.css";
import Lightbox from "react-image-lightbox";

interface ImageGalleryProps {
  //   rowData: any;
  materialId: number;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    videoBigTitle: {
      fontSize: 24,
      fontWeight: 900,
      fontFamily: "Noto Sans KR",
      paddingBottom: 16,
      [theme.breakpoints.down("xs")]: { paddingBottom: 8 },
    },
    imgContainer: {
      [theme.breakpoints.down("xs")]: { padding: 0 },
    },
  })
);

function ImageGallery({ materialId }: ImageGalleryProps) {
  const classes = useStyles();
  const theme = useTheme();
  const mdMatches = useMediaQuery(theme.breakpoints.down("md"));
  
  const [imgArray, setImgArray] = useState<any>(null);
  const [imgIndex, setImgIndex] = useState<number>(0);
  const [isOpen, setIsOpen] = useState<Boolean>(false);
  const [breakpointColumnsObj, setBreakPoint] = useState<any>({
    default: 4,
    1100: 3,
    700: 2,
    500: 1,
  });
  const customStyles = {
    content: {
      top: parseInt(`${!mdMatches ? 72 : 56}`),
      left: "0%",
      // right: "auto",
      // bottom: "auto",
      // marginRight: "-50%",
      // transform: "translate(-50%, -50%)",
    },
  };

  const { data, loading, error } = useQuery(
    GET_MATERIAL_IMAGES_BY_SUB_CATEGORY_ID,
    {
      variables: {
        fetchPolicy: "no-cache",

        where: {
          archive_sub_category: {
            id: materialId,
          },
        },
      },
    }
  );

  useEffect(() => {
    if (data && data.materialImages) {
      if (data.materialImages.length > 0) {
        setImgArray(data.materialImages[0].images);
      }
    }
    return () => {
      setImgArray(null);
    };
  }, [data, materialId]);

  useEffect(() => {
    if (imgArray && imgArray.length == 1) {
      setBreakPoint({
        default: 1,
        1100: 1,
        700: 1,
        500: 1,
      });
    } else if (imgArray && imgArray.length == 2) {
      setBreakPoint({
        default: 2,
        1100: 2,
        700: 2,
        500: 1,
      });
    } else if (imgArray && imgArray.length == 3) {
      setBreakPoint({
        default: 3,
        1100: 3,
        700: 2,
        500: 1,
      });
    } else {
      setBreakPoint({
        default: 4,
        1100: 3,
        700: 2,
        500: 1,
      });
    }
    return () => {};
  }, [imgArray]);

  if (loading) return null;
  if (data === undefined) return null;
  if (error || !data.materialImages) {
    console.log(error);
  }

  //   const childElements = imgArray.map(function (element: any) {
  //     return (
  //       <li className="image-element-class">
  //         <img src={element.src} />
  //       </li>
  //     );
  //   });

  // const breakpointColumnsObj = {
  //   default: 4,
  //   1100: 3,
  //   700: 2,
  //   500: 1,
  // };

  return (
    <Container maxWidth={false} disableGutters={true}>
      <Grid alignItems="center" justify="center" xs={12} container item>
        {imgArray ? (
          <React.Fragment>
            <Grid xs={12} item>
              <p
                style={{
                  fontSize: 24,
                  fontWeight: 900,
                  fontFamily: "Noto Sans KR",
                  paddingBottom: 16,
                }}
              >
                사진 자료
              </p>
            </Grid>
            <Grid xs={12} item>
              {isOpen && (
                <Lightbox
                  // mainSrc={images[lightBoxState.photoIndex]}
                  reactModalStyle={customStyles}
                  mainSrc={imgArray[imgIndex].url}
                  nextSrc={imgArray[(imgIndex + 1) % imgArray.length]}
                  prevSrc={
                    imgArray[(imgIndex + imgArray.length - 1) % imgArray.length]
                  }
                  onCloseRequest={() => setIsOpen(false)}
                  onMovePrevRequest={() =>
                    setImgIndex(
                      (imgIndex + imgArray.length - 1) % imgArray.length
                    )
                  }
                  onMoveNextRequest={() =>
                    setImgIndex((imgIndex + 1) % imgArray.length)
                  }
                />
              )}

              <Masonry
                breakpointCols={breakpointColumnsObj}
                className="my-masonry-grid"
                columnClassName="my-masonry-grid_column"
              >
                {imgArray.map((element: any, index: any) => {
                  return (
                    <Grid key={`archive-masonry-grid-${index}`}>
                      <div
                        onClick={() => {
                          setImgIndex(index);
                          setIsOpen(true);
                        }}
                        key={`image-gallery-${element.url}-${index}`}
                      >
                        <img
                          src={element.url}
                          style={{
                            width: "100%",
                          }}
                        />
                      </div>
                    </Grid>
                  );
                })}
              </Masonry>
            </Grid>
          </React.Fragment>
        ) : (
          <div></div>
        )}
      </Grid>
    </Container>
  );
}
export default ImageGallery;
